import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { filter, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BrandingInfo } from '../models/branding-info.model';

export const publicRoutes: string[] = ['/public-details', '/public-service-browser', '/public-report', '/access-denied'];



@Injectable({
  providedIn: 'root'
})
export class PublicRequestService {

  private http: HttpClient;

  constructor(private httpBackend: HttpBackend, private router: Router) {
    this.http = new HttpClient(httpBackend);
  }
  baseUrlTracking = environment.tracking_url;
  baseUrlIdentity = environment.identity_url;

  activeRoutesTrackingRaw(orderHash: string): Observable<any> {
    const url = `${this.baseUrlTracking}/fleet-manager/services/${orderHash}/tracking`;
    return this.http.get(url);
  }

  isPublicRoute(): boolean {
    const currentUrl = this.router.url;
    return publicRoutes.some(route => currentUrl.startsWith(route));
  }

  activeRoutesTrackingBranding(brandingId: string): Observable<BrandingInfo> {
    const url = `${this.baseUrlIdentity}/branding-details?brandingId=${brandingId}`;
    return this.http.get<BrandingInfo>(url);
  }

  getServiceByLicensePlateAndDate(licensePlate: string, date: string): Observable<string[]> {
    const url = `${this.baseUrlTracking}/fleet-manager/services/tracking-list?licensePlate=${licensePlate}&date=${date}`;
    return this.http.get<string[]>(url);
  }

}



